module.exports = __webpack_public_path__ + "static/happy-money-d61701a18eaf56eee8802e976629dcfd.jpg";